export default __webpack_public_path__ + "static/media/LolChampionGalleryImg_1.dfe66190.webp";